import React, { useCallback, useEffect, useState } from 'react';
import api from '../api';
import Modal from '../components/Modal';

const LEER = { nachname: '', vorname: '', telefon: '', email: '', rolle_id: '', aktiv: true, benutzer_id: '', gruppen: [] };

function MitgliedDialog({ mitglied, gruppen, rollen, logins, belegteLogins, onClose, onGespeichert }) {
  const [form, setForm] = useState(() => (mitglied
    ? { ...LEER, ...mitglied, telefon: mitglied.telefon || '', email: mitglied.email || '', benutzer_id: mitglied.benutzer_id || '', gruppen: mitglied.gruppen || [] }
    : { ...LEER, rolle_id: rollen[0]?.id || '' }));
  const [fehler, setFehler] = useState('');
  const [speichern, setSpeichern] = useState(false);
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const absenden = async () => {
    if (!form.nachname.trim() || !form.vorname.trim()) return setFehler('Vor- und Nachname sind Pflicht');
    if (!form.rolle_id) return setFehler('Bitte eine Rolle wählen');
    setSpeichern(true); setFehler('');
    try {
      const daten = { ...form, benutzer_id: form.benutzer_id || null };
      if (mitglied) await api.put(`/api/admin/team/${mitglied.id}`, daten);
      else await api.post('/api/admin/team', daten);
      onGespeichert();
    } catch (err) {
      setFehler(err.response?.data?.error || 'Speichern fehlgeschlagen');
    } finally { setSpeichern(false); }
  };

  const loeschen = async () => {
    if (!window.confirm(`${mitglied.vorname} ${mitglied.nachname} wirklich löschen?`)) return;
    try {
      await api.delete(`/api/admin/team/${mitglied.id}`);
      onGespeichert();
    } catch (err) { setFehler(err.response?.data?.error || 'Löschen fehlgeschlagen'); }
  };

  const toggleGruppe = (id) => set('gruppen', form.gruppen.includes(id) ? form.gruppen.filter(g => g !== id) : [...form.gruppen, id]);

  return (
    <Modal title={mitglied ? `${mitglied.vorname} ${mitglied.nachname}` : 'Person hinzufügen'} onClose={onClose} size="md">
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 0.75rem' }}>
        <div className="form-group"><label className="form-label">Nachname *</label>
          <input className="form-control" value={form.nachname} maxLength={100} autoFocus onChange={e => set('nachname', e.target.value)} /></div>
        <div className="form-group"><label className="form-label">Vorname *</label>
          <input className="form-control" value={form.vorname} maxLength={100} onChange={e => set('vorname', e.target.value)} /></div>
        <div className="form-group"><label className="form-label">Telefon</label>
          <input className="form-control" type="tel" value={form.telefon} maxLength={50} onChange={e => set('telefon', e.target.value)} /></div>
        <div className="form-group"><label className="form-label">E-Mail</label>
          <input className="form-control" type="email" value={form.email} maxLength={255} onChange={e => set('email', e.target.value)} /></div>
        <div className="form-group"><label className="form-label">Rolle</label>
          <select className="form-control" value={form.rolle_id} onChange={e => set('rolle_id', e.target.value)}>
            <option value="">– wählen –</option>
            {rollen.filter(r => r.aktiv || r.id === mitglied?.rolle_id).map(r => (
              <option key={r.id} value={r.id}>{r.name}{r.aktiv ? '' : ' (inaktiv)'}</option>
            ))}
          </select></div>
        <div className="form-group"><label className="form-label">Trainer-Login (optional)</label>
          <select className="form-control" value={form.benutzer_id} onChange={e => set('benutzer_id', e.target.value)}>
            <option value="">– kein Login –</option>
            {logins.filter(l => !belegteLogins.has(l.id) || l.id === Number(mitglied?.benutzer_id)).map(l => (
              <option key={l.id} value={l.id}>{l.vorname} {l.nachname} ({l.email})</option>
            ))}
          </select></div>
      </div>
      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', margin: '-0.4rem 0 0.75rem' }}>
        Mit Login kann die Person in der Trainer-App einchecken (für ihre Gruppen) und ihre eigenen Stunden sehen.
        Wer ein Training startet, wird automatisch eingecheckt.
      </div>

      <div className="form-group">
        <label className="form-label">Stammteam in den Gruppen</label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
          {gruppen.map(g => (
            <label key={g.id} style={{
              display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', borderRadius: 16, cursor: 'pointer', fontSize: '0.85rem',
              border: `1px solid ${form.gruppen.includes(g.id) ? 'var(--primary)' : 'var(--border)'}`,
              background: form.gruppen.includes(g.id) ? '#e3f2fd' : '#fff', opacity: g.aktiv === false ? 0.6 : 1,
            }}>
              <input type="checkbox" checked={form.gruppen.includes(g.id)} onChange={() => toggleGruppe(g.id)} /> {g.name}
            </label>
          ))}
        </div>
        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 4 }}>
          Nur Vorauswahl beim Einchecken – Vertretungen in anderen Gruppen sind jederzeit möglich.
        </div>
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.9rem', marginBottom: '0.75rem', cursor: 'pointer' }}>
        <input type="checkbox" checked={form.aktiv} onChange={e => set('aktiv', e.target.checked)} /> aktiv
      </label>

      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', background: '#f4f7fb', borderRadius: 6, padding: '0.5rem 0.7rem', marginBottom: '0.75rem' }}>
        Helfer sind meist minderjährig: Telefon und E-Mail nur mit Einverständnis (bei Minderjährigen der Erziehungsberechtigten)
        erfassen und nicht weitergeben.
      </div>

      {fehler && <div className="alert alert-error">{fehler}</div>}
      <div className="modal-actions">
        {mitglied && (mitglied.einsaetze === 0
          ? <button className="btn btn-danger btn-sm" onClick={loeschen}>Löschen</button>
          : <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{mitglied.einsaetze} Einsätze erfasst – statt löschen „aktiv" abwählen</span>)}
        <button className="btn btn-secondary btn-sm" style={{ marginLeft: 'auto' }} onClick={onClose}>Abbrechen</button>
        <button className="btn btn-primary btn-sm" onClick={absenden} disabled={speichern}>{speichern ? 'Speichern…' : 'Speichern'}</button>
      </div>
    </Modal>
  );
}

export default function Team() {
  const [liste, setListe] = useState([]);
  const [gruppen, setGruppen] = useState([]);
  const [logins, setLogins] = useState([]);
  const [rollen, setRollen] = useState([]);
  const [laden, setLaden] = useState(true);
  const [fehler, setFehler] = useState('');
  const [filter, setFilter] = useState('aktiv');
  const [dialog, setDialog] = useState(null); // null | 'neu' | mitglied

  const load = useCallback(async () => {
    try {
      const [t, g, l, r] = await Promise.all([
        api.get('/api/admin/team'), api.get('/api/admin/gruppen'), api.get('/api/admin/trainer-benutzer'),
        api.get('/api/admin/rollen'),
      ]);
      setListe(t.data); setGruppen(g.data); setLogins(l.data); setRollen(r.data.rollen || []);
    } catch { setFehler('Team konnte nicht geladen werden'); }
    finally { setLaden(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const gruppenName = new Map(gruppen.map(g => [g.id, g.name]));
  const belegteLogins = new Set(liste.filter(m => m.benutzer_id).map(m => m.benutzer_id));
  const sichtbar = liste.filter(m => filter === 'alle' || (filter === 'aktiv' ? m.aktiv : !m.aktiv));

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Team <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontSize: '1rem' }}>
          ({liste.filter(m => m.aktiv).length} aktiv)</span></h2>
        <button className="btn btn-primary btn-sm" onClick={() => setDialog('neu')}>+ Person</button>
      </div>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginBottom: '1rem' }}>
        Trainer und Helfer, die beim Training eingecheckt werden. Die Rollen und ihre Stundensätze stehen
        unter „Rollen &amp; Vergütung", die erfassten Stunden unter „Trainer-/Helferstunden".
      </p>

      {fehler && <div className="alert alert-error">{fehler}</div>}

      <div className="card">
        <div className="toolbar">
          <select className="filter-select" value={filter} onChange={e => setFilter(e.target.value)}>
            <option value="aktiv">Aktive</option><option value="inaktiv">Inaktive</option><option value="alle">Alle</option>
          </select>
        </div>
        {laden ? <div style={{ padding: '2rem', textAlign: 'center' }}><div className="loading-spinner" style={{ margin: '0 auto' }} /></div> : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Name</th><th>Rolle</th><th>Kontakt</th><th>Stammteam</th><th>Login</th><th>Einsätze</th></tr></thead>
              <tbody>
                {sichtbar.length === 0 && <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem' }}>Keine Personen</td></tr>}
                {sichtbar.map(m => (
                  <tr key={m.id} style={{ cursor: 'pointer', opacity: m.aktiv ? 1 : 0.55 }} onClick={() => setDialog(m)}>
                    <td style={{ fontWeight: 600 }}>{m.nachname}, {m.vorname}</td>
                    <td>{m.rolle_name}</td>
                    <td style={{ fontSize: '0.8rem' }}>{m.telefon}<div className="td-muted">{m.email}</div></td>
                    <td style={{ fontSize: '0.8rem' }}>{m.gruppen.map(id => gruppenName.get(id)).filter(Boolean).join(', ') || '–'}</td>
                    <td style={{ fontSize: '0.8rem' }}>{m.benutzer_name ? `✓ ${m.benutzer_name}` : '–'}</td>
                    <td>{m.einsaetze}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {dialog && (
        <MitgliedDialog mitglied={dialog === 'neu' ? null : dialog} gruppen={gruppen} rollen={rollen} logins={logins} belegteLogins={belegteLogins}
          onClose={() => setDialog(null)} onGespeichert={() => { setDialog(null); load(); }} />
      )}
    </div>
  );
}
